import React from 'react'
import { Input } from 'reactstrap'
import { AnnouncementsBoxProps } from './../types'
import componentStyle from './AnnouncementsBox.module.scss'

const AnnouncementsBox: React.FC<AnnouncementsBoxProps> = ({ handleChange, disable }) => {

  return <div className={ componentStyle['announcements-announcementsbox-container']} data-bdd="announcements-announcementsbox-container">
    <div className={ componentStyle['announcementsbox-sec']}>
      <div><strong>Display a real time announcement to your live audience:</strong></div>
      <Input
        disabled={disable}
        type='textarea'
        name='announcementText'
        maxLength={1000}
        className={ componentStyle['announcementsbox-input'] }
        placeholder='Type announcement...'
        onChange={handleChange}
        data-bdd='announcements-announcementsbox-input'
      />
    </div>
  </div>

}

export default AnnouncementsBox
